export default "__VITE_ASSET__06039fad__"